import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import CgRadixButton from 'modules/Common/ui/CgRadixButton';
import { CALENDLY_ONBOARDING_URL } from '../utils/constants';
import { useTranslation } from 'react-i18next';

const CalendlyBookingStep = ({ onContinue }) => {
  const { t } = useTranslation('onboarding');
  // Mount as a plain iframe instead of Calendly's initInlineWidget. The widget
  // helper appends `embed_type=Inline` to the URL, which switches Calendly's
  // page into embed-mode CSS: it hides "Cookie settings" and zeroes the
  // footer container's left padding, leaving "Privacy Policy" flush against
  // the left edge. Direct iframe → same Calendly page in its standalone
  // layout, with the footer indent intact.
  const iframeSrc = CALENDLY_ONBOARDING_URL;

  return (
    <div>
      <div className="text-center mb-6">
        <div className="inline-flex w-12 h-12 rounded-2xl bg-primaryColor/10 text-primaryColor items-center justify-center mb-4">
          <FontAwesomeIcon
            icon={faCalendarCheck}
            className="text-xl"
          />
        </div>
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-green-50 text-green-700 text-[10px] font-bold uppercase tracking-wider mb-3">
          {t('booking.allSet', "You're all set")}
        </span>
        <h2 className="text-2xl font-semibold text-slate-800 m-0">
          {t('booking.wantWalkthrough', 'Want a personal walkthrough?')}
        </h2>
        <p className="text-sm text-slate-500 mt-2 max-w-xl mx-auto">
          {t('booking.bookCallWith', 'Book a free onboarding call with')}{' '}
          <span className="font-medium text-slate-700">
            {t('booking.victorCeo', 'Victor, our CEO')}
          </span>{' '}
          {t(
            'booking.bookCallBody',
            "— he'll walk you through the platform and answer your questions. You can also skip and start exploring on your own; booking is always available later.",
          )}
        </p>
      </div>

      <div className="rounded-2xl mb-5 bg-white">
        <iframe
          src={iframeSrc}
          title={t('booking.bookSession', 'Book an onboarding session')}
          style={{ minWidth: '320px', width: '100%', height: '720px', border: 0, display: 'block' }}
        />
      </div>

      <div className="flex justify-end">
        <CgRadixButton
          variant="primary"
          size="lg"
          onClick={onContinue}
          icon={faArrowRight}
        >
          {t('actions.continueToPlatform', 'Continue to platform')}
        </CgRadixButton>
      </div>
    </div>
  );
};

CalendlyBookingStep.propTypes = {
  onContinue: PropTypes.func.isRequired,
};

export default CalendlyBookingStep;
